import React, { useEffect } from "react";
import {
  Button,
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Empty,
  Timeline,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import {
  getFDetails,
  updatePaymentReview,
  updateConfirmPayment,
} from "../../actions/finance";

import { Title, Wrapper } from "./detailStyle";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import {
  CheckCircleOutlined,
  EyeOutlined,
 
} from "@ant-design/icons";

import Remarks from "../../component/remark";

const FinanceOrderDetails = ({
  location,
  getFDetails,
  updatePaymentReview,
  updateConfirmPayment,
}) => {
  const [data, setData] = useState([]);
  const [review, setReview] = useState(false);
  const [confirm, setConfirm] = useState(false);

  useEffect(async () => {
    const id = new URLSearchParams(location.search).get("id");
    const res = await getFDetails(id);
    setData(res);
  }, []);

  
  const handleRefresh = async () => {
    const res = await getFDetails(data?.batch_id);
    setData(res);
  };

  const makeLocalTime = (date) => {
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      date.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };
  return (
    <Content style={{ margin: "0 16px" }}>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Order Details</Breadcrumb.Item>
      </Breadcrumb>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Order Details"
        subTitle="Finance Management"
      ></PageHeader>
      <Wrapper>
        <h2>Batch Id : {data?.batch_id}</h2>
        <h3>Batch No: {data?.batch_no}</h3>
        <h3>Title: BDT {data?.title}</h3>

        {data?.payment_status === "unpaid" ? (
          <Tag color="#f50">{data?.payment_status}</Tag>
        ) : (
          <Tag color="#108ee9">{data?.payment_status}</Tag>
        )}
        {data?.payment_review === false ? (
          <Tag color="#f50">Unreviewed</Tag>
        ) : (
          <Tag color="#108ee9">Reviewed</Tag>
        )}

        {data?.payment_review !== true ? (
          data?.payment_status === "paid" ? (
            <Button
              type="ghost"
              icon={<EyeOutlined />}
              size="small"
              style={{
                float: "right",
                backgroundColor: "#45cef0",
                color: "#fff",
              }}
              onClick={() => setReview(true)}
            >
              Review
            </Button>
          ) : null
        ) : null}

        {data?.payment_status !== "paid" ? (
          <Button
            type="ghost"
            icon={<CheckCircleOutlined />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#45cef0",
              color: "#fff",
            }}
            onClick={() => setConfirm(true)}
          >
            Confirm Payment
          </Button>
        ) : null}
        <br />
        <br />
        {data ? (
          <>
            <Title>Client Information</Title>
            <Descriptions>
              <Descriptions.Item label="NAME">
                <strong>{data?.client?.name?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="EMAIL">
                <strong>{data?.client?.email?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="BRAND NAME">
                <strong>{data?.client?.brand_name?.toUpperCase()}</strong>
              </Descriptions.Item>
            </Descriptions>

            <Title>Payment Information</Title>
            {data ? (
              <Descriptions>
                <Descriptions.Item label="UNIT COST">
                  <strong>BDT {data?.unit_cost}</strong>
                </Descriptions.Item>
                <Descriptions.Item label="TOTAL CODE">
                  <strong>{data?.code_count}</strong>
                </Descriptions.Item>
                <Descriptions.Item label="TOTAL COST">
                  <strong>BDT {data?.total_cost}</strong>
                </Descriptions.Item>

                <Descriptions.Item label="REVIEWED">
                  <strong>{data?.payment_review ? "YES" : "NO"}</strong>
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <Empty />
            )}
            <Title>Logs</Title>
            <br />
            {data?.logs ? (
              <Timeline mode="left">
                {data.logs.map((item, index) => (
                  <Timeline.Item
                    label={makeLocalTime(item?.created_at)}
                    keys={index}
                  >
                    {item?.message}
                  </Timeline.Item>
                ))}
              </Timeline>
            ) : (
              <Empty />
            )}
          </>
        ) : null}
        <br />
        <br />
      </Wrapper>
      <Remarks
        title=" "
        btn="Review"
        placement="bottom"
        visible={review}
        fnc={() => setReview(false)}
        id={data?.batch_id}
        delFnc={updatePaymentReview}
        refresh={handleRefresh}
      />
      <Remarks
        title=" "
        btn="Review"
        placement="bottom"
        visible={confirm}
        fnc={() => setConfirm(false)}
        id={data?.batch_id}
        delFnc={updateConfirmPayment}
        refresh={handleRefresh}
      />
     
    </Content>
  );
};

export default connect(null, {
  getFDetails,
  updatePaymentReview,
  updateConfirmPayment,
})(FinanceOrderDetails);
